import { createRoot } from "react-dom/client";
import { App } from "./App";
import { initGa4 } from "@/lib/analytics/ga4";
import "./index.css";
import "./styles/refurbly-spinner.css";

initGa4();

createRoot(document.getElementById("root")!).render(<App />);
